export default __webpack_public_path__ + "static/media/Icon32.52389b6a.svg";